export default __webpack_public_path__ + "waves-download-section.svg";